import React from 'react';
import Label from "../../UI/Label";
import { trackPropTypes, tracksWidth, arrowWidth } from "../../../config/defaults";
import { getLabelColorByStateAndDifficulty, getTrackColorByStateAndDifficulty } from "../../../helpers/map";
import { TRACK_DIFFICULTY_BLUE } from "../../../config/constants";
import TrackArrow from "../../UI/TrackArrow";

const Track7BBlue = ({ state, workState, onLabelClick }) => (
	<g id="Track7BBlue" transform="translate(1585.000000, 936.000000)" className="track">
		<g id="line" stroke={getTrackColorByStateAndDifficulty(state, workState, TRACK_DIFFICULTY_BLUE)}
			 strokeLinecap="round" strokeWidth={tracksWidth}
		>
			<path
				d="M45.8812196,173.861933 L90.0488361,165.686128 C95.4794271,164.680879 99.0668756,159.4636 98.0616266,154.033008 C97.8255083,152.757442 97.3434606,151.540002 96.6423529,150.448548 L0,0 L0,0"/>
			<path
				d="M23.1494139,214.162229 L21.1252789,199.512903 C19.9990499,191.362016 23.9798479,183.353144 31.1573523,179.329616 L32.173895,178.759768 L32.173895,178.759768"/>

			<TrackArrow transform="translate(30.080060, 180.513685) rotate(-222.000000) translate(-30.080060, -180.513685) "
									points="34.0800602 188.513685 26.0800602 180.513685 34.0800602 172.513685"/>
		</g>

		<Label
			onClick={(event, ref) => onLabelClick(event, ref, 'Track7BBlue')}
			coords="57.000000, 150.000000"
			text="7B"
			textCoordsX="11.0351562"
			colors={getLabelColorByStateAndDifficulty(state, workState, TRACK_DIFFICULTY_BLUE)}
		/>
	</g>

);

Track7BBlue.propTypes = trackPropTypes;

export default Track7BBlue;
